<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <qr-code
        class="qr"
        :text="text"
        :value="text"
        :size="size"
        color="black"
        bg-color="white"
        error-level="L"
      ></qr-code>
      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <h2 class="mt-8">{{ code }}</h2>
      <v-spacer></v-spacer>
    </v-row>
  </div>
</template>
<script>
  import MixinShared from '@/Mixins/Shared';
  export default {
    mixins: [MixinShared],
    data() {
      return {
        text: '',
        code: '',
        size: 500,
      };
    },
    created() {
      let route = this.$route.query.data;
      let routeInfo = route.split('$$__$$');
      this.text = routeInfo[0];
      this.code = routeInfo[1];
    },
    mounted() {
      this.mounte();
    },
    methods: {
      mounte: function () {
        this.mounteLoding();
      },
    },
  };
</script>
<style scoped>
  .qr {
    margin-top: 5% !important;
  }
</style>
